import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import InnerBox from '@repo/ui/inner-box'
import { useForm } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import FormError from '../../elements/FormError'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'
import StaffApplicationFormAvailability from './staff-application-form-availability'
import StaffApplicationFormCountriesWishList from './staff-application-form-countries-wish-list'
import StaffApplicationFormEducation from './staff-application-form-education'
import StaffApplicationFormHobbies from './staff-application-form-hobbies'
import StaffApplicationFormLanguage from './staff-application-form-language'
import StaffApplicationFormPersonalInformation from './staff-application-form-personal-information'
import StaffApplicationFormProfessionalExperience from './staff-application-form-professional-experience'
import StaffApplicationFormStatus from './staff-application-form-status'
import { staffApplicationFormSchema } from './utils'

type Props = BaseFormProps<StaffApplicationInput, true> & {
  staffApplicationId: number
  readOnly?: boolean
}

const StaffApplicationForm = ({
  staffApplicationId,
  defaultValues,
  readOnly,
  ...validationButtonProps
}: Props) => {
  const { t } = useTranslate()
  const form = useForm<StaffApplicationInput>({
    resolver: zodResolver(staffApplicationFormSchema(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div
          className={cn('flex w-full gap-2', {
            'pointer-events-none': readOnly
          })}
        >
          <div className=" w-full flex flex-col gap-4 ">
            <StaffApplicationFormStatus staffApplicationId={staffApplicationId} />
            <StaffApplicationFormPersonalInformation />
            <StaffApplicationFormLanguage />
            <StaffApplicationFormHobbies />
          </div>
          <div className="w-full flex flex-col gap-4 ">
            <StaffApplicationFormProfessionalExperience />
            <StaffApplicationFormEducation />
            <StaffApplicationFormCountriesWishList />
            <StaffApplicationFormAvailability />

            <InnerBox title="Motivation">
              <div className="flex flex-col gap-3">
                <FormField
                  control={form.control}
                  name="motivation"
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <ControlledInput {...field} label="Motivation" type="textarea" />
                      </FormControl>
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="experience"
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <ControlledInput {...field} label="Expérience" type="textarea" />
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>
            </InnerBox>
            <InnerBox title="Commentaire">
              <FormField
                control={form.control}
                name="comments"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <ControlledInput {...field} label="Commentaire" type="textarea" />
                    </FormControl>
                  </FormItem>
                )}
              />
            </InnerBox>
          </div>
        </div>
        <ValidationButtons {...validationButtonProps} />
        <FormError />
      </form>
    </Form>
  )
}

export default StaffApplicationForm
